module.exports = __webpack_public_path__ + "dataanalysestatic/img/genshu.748e2f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/genshu.png
// module id = FFwg
// module chunks = 37